var client_id = process.env.REACT_APP_SPOTIFY_CLIENT_ID;
var redirect_uri = "https://damiangengigih.vercel.app/";


var state = "damian_homework3";

localStorage.setItem("TOKEN", state);
var scope = "playlist-modify-private";

var url = "https://accounts.spotify.com/authorize";
url += "?response_type=token";
url += "&client_id=" + encodeURIComponent(client_id);
url += "&scope=" + encodeURIComponent(scope);
url += "&redirect_uri=" + encodeURIComponent(redirect_uri);
url += "&state=" + encodeURIComponent(state);

export default url;
